import getCalendarDateText, { getCalendarDateText as getCalendarDateTextNamed } from './get-calendar-date-text';

export default getCalendarDateText;
export { getCalendarDateTextNamed as getCalendarDateText };
